export const FilterModal = (props) => {
    const { activeModal, filters, updateFilters, syncFiltersToParams, closeModal, filterCity, filterLanguages, feeRanges, expYears } = props;
     console.log("feeRanges",feeRanges)

    const renderOptions = (title, key, options) => (
        <>
        <h6 style={{ marginBottom: "10px" }}>{title}</h6>
        <div className="modal-scroll-container">
          {options.map((opt) => (
              <label key={opt} className="modal-radio-option">
              <input
                  type="radio"
                  name={key}
                  checked={filters[key] === opt}
                  onChange={() => {
                    updateFilters(
                      { [key]: opt },
                      syncFiltersToParams
                    );
                  }}
              />
              <span className="radio-label">{opt}</span>
              </label>
          ))}
        </div>
        </>
    );

    const renderCityOptions = () => (
        <>
            <h6 style={{ marginBottom: "10px" }}>City</h6>
            <div className="modal-scroll-container">
              {filterCity.map((item) => (
                  <label key={item._id} className="modal-radio-option">
                  <input
                      type="radio"
                      name="city"
                      checked={filters.city === item._id}
                      onChange={() => {
                        updateFilters(
                          { city: item._id },
                          syncFiltersToParams
                        );
                      }}
                  />
                  <span className="radio-label">
                      {item.city}
                  </span>
                  </label>
              ))}
            </div>
        </>
    );

  return (
    <div className="filter-modal-overlay">
      <div className="filter-modal">

        <div className="modal-close" onClick={closeModal}>
          <i className="fa-regular fa-x fa-sm" style={{ color: "#be97f2" }}></i>
        </div>

        <div className="modal-content modal-content-style">
          {activeModal === "fee" && (
            <>
              <div style={{ display: "flex", gap: "30px" }}>

                <div style={{ flex: 1 }}>
                    <h6 style={{ marginBottom: "10px" }}>Online</h6>

                    {feeRanges.map((range) => (
                    <label key={`online-${range}`} className="modal-radio-option">
                        <input
                        type="radio"
                        name="feeRangeGroup"
                        checked={filters.feesNumber === range}
                        onChange={() => {
                          updateFilters(
                            {
                              feesNumber: range,
                            },
                            syncFiltersToParams
                          );
                        }}
                        />
                        <span className="radio-label">{range}</span>
                    </label>
                    ))}
                </div>

                <div style={{ flex: 1 }}>
                    <h6 style={{ marginBottom: "10px" }}>Clinic</h6>

                    {feeRanges.map((range) => (
                    <label key={`physical-${range}`} className="modal-radio-option">
                        <input
                        type="radio"
                        name="feeRangeGroup"
                        checked={filters.physicalFee === range}
                        onChange={() => {
                          updateFilters(
                            {
                              physicalFee: range,
                            },
                            syncFiltersToParams
                          );
                        }}
                        />
                        <span className="radio-label">{range}</span>
                    </label>
                    ))}
                </div>

              </div>
            </>
          )}

          {activeModal === "experienceNumber" && (
             <div style={{ flex: 1 }}>
                  <h6 style={{ marginBottom: "10px" }}>Experience</h6>

                  {expYears.map((years) => (
                  <label key={`physical-${years}`} className="modal-radio-option">
                      <input
                      type="radio"
                      name="feeRangeGroup"
                      checked={filters.experienceNumber === years}
                      onChange={() => {
                        updateFilters(
                          {
                            experienceNumber: years,
                          },
                          syncFiltersToParams
                        );
                      }}
                      />
                      <span className="radio-label">{years}</span>
                  </label>
                  ))}
             </div>
          )}

          {activeModal === "language" &&
            renderOptions("Language", "language", filterLanguages)}

          {activeModal === "gender" &&
            renderOptions("Gender", "gender", [
              "M",
              "F",
            ])}

          {activeModal === "city" &&
            renderCityOptions()
          }
        </div>

      </div>
    </div>
  );
};
